export default [
  {
    type: '1',
    title: '聆听历史回响 阔步新的长征',
    time: 1635239891126
  },
  {
    type: '2',
    title: '继往开来，重整行装再出发',
    time: 1634552310154
  },
  {
    type: '3',
    title: '把握数字经济发展趋势和规律 推动我国数字经济健康发展',
    time: 1635239891126
  },
  {
    type: '4',
    title: '常想身后留什么',
    time: 1634552310154
  },
  {
    type: '5',
    title: '激发人才创新创造活力（专家点评）',
    time: 1635239891126
  },
  {
    type: '1',
    title: '“青山见证他的忠诚”',
    time: 1634552310154
  }
]